import { Component, OnInit, Input } from '@angular/core';
import { CollectionService } from '../services/collection.service';
import { MapPosition } from '../models/map-position.model';
import { Place } from '../models/place.model';
import { LatLngBounds } from '@agm/core/services/google-maps-types';
import { MapService } from '../services/map.service';

@Component({
  selector: 'app-mini-map',
  templateUrl: './mini-map.component.html',
  styleUrls: ['./mini-map.component.scss'],
})
export class MiniMapComponent implements OnInit {
  @Input()
  collectionId: any;

  @Input()
  pluginUrl: any = '';

  location: MapPosition;
  groupedPlaces: [];
  isLoading = false;
  totalSize = 0;
  openInfoWindow = null;

  private pinUrl = this.pluginUrl + '/assets/img/pin.png';

  private moveCount = 0;
  private moveEnabled = true;

  constructor(
    private collectionService: CollectionService,
    private mapService: MapService
  ) {
    this.mapService.toggleMap.subscribe((enabled) => {
      this.moveEnabled = enabled;
    });
  }

  ngOnInit() {
    this.loadResults();

    this.location = new MapPosition();
    //this.location.zoom = 6;
  }

  loadResults() {
    this.isLoading = true;

    this.collectionService
      .get(this.collectionId, 1000)
      .subscribe((response) => {
        this.totalSize = Number(response.headers.get('totalsize'));
        this.isLoading = false;

        const places = response.json();

        this.groupedPlaces = this.groupByLocations(places);
      });
  }

  onPlaceClick(infoWindow) {
    this.moveEnabled = false;

    if (this.openInfoWindow != null) {
      this.openInfoWindow.close();
    }

    this.openInfoWindow = infoWindow;

    setTimeout(() => (this.moveEnabled = true), 500);
  }

  groupByLocations(places) {
    var helper = { places: [] };

    var result = places.reduce(function (r, o) {
      var key = o.location.lat + '-' + o.location.lng;

      if (!helper[key]) {
        helper[key] = { places: [] };
        helper[key].places.push(o);
        r.push(helper[key]);
      } else {
        helper[key].places.push(o);
      }

      return r;
    }, []);

    return result;
  }
}
